<template>
  <div class="d-flex justify-center">
    <div class="d-flex flex-row input-container">
      <InputDiscount :discount="discount" @onChangeDiscount="handleChangeDiscount" />
      <template v-if="canEditOffer">
        <div class="d-flex flex-column justify-center">
          <v-icon :disabled="isIncreaseBtnDisabled" @click="handleClickIncrease">
            mdi-plus-box
          </v-icon>
          <v-icon :disabled="isDecreaseBtnDisabled" @click="handleClickDecrease">
            mdi-minus-box
          </v-icon>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import InputDiscount from '@/containers/offer-form/shipping/InputDiscount'
import { mapGetters } from 'vuex'

export default {
  name: 'InputDiscountGroup',
  components: {
    InputDiscount,
  },
  props: {
    zone: {
      type: String,
    },
    initValue: {
      type: Number,
    },
    areCurrentDiscountsLocked: {
      type: Boolean,
    },
    maxDiscountRate: {
      type: Number,
    },
  },
  data() {
    return {
      zero: 0,
    }
  },
  computed: {
    ...mapGetters('offer', ['canEditOffer']),
    discount() {
      const value = this.initValue * 100

      return value === 100 ? value.toString() : value.toFixed(2)
    },
    isIncreaseBtnDisabled() {
      return this.areCurrentDiscountsLocked && this.discount / 100 >= this.maxDiscountRate
    },
    isDecreaseBtnDisabled() {
      return Number(this.discount) === 0
    },
  },
  methods: {
    handleChangeDiscount(value) {
      let newValue = parseFloat(value)

      if (newValue < 0) {
        newValue = 0
      } else if (this.areCurrentDiscountsLocked && newValue > this.maxDiscountRate * 100) {
        newValue = this.maxDiscountRate * 100
      } else if (newValue > 100) {
        newValue = 100
      }

      this.$emit('onChange', this.zone, newValue / 100)
    },
    handleClickIncrease() {
      this.handleChangeDiscount(parseFloat(this.discount) + 0.1)
    },
    handleClickDecrease() {
      this.handleChangeDiscount(parseFloat(this.discount) - 0.1)
    },
  },
}
</script>

<style scoped lang="scss">
.input-container {
  width: 108px;
}
</style>
